module.exports = __webpack_public_path__ + "img/choose-up-Up Cadou STIM-disabled.cee2064e.png";